import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { FormWrapper } from "./components/FormWrapper/FormWrapper"
import styles from "./index.module.css"

export const Content: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Head}>
        <Heading className={styles.Heading} like="h1">
          <Raw html={t("submit-application.Heading")} />
        </Heading>

        <div
          className={styles.Description}
          dangerouslySetInnerHTML={{ __html: t("submit-application.Description") }}
        />
      </div>

      <FormWrapper />
    </div>
  )
}
